<template>
    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
        <title>mail</title>
        <path d="M22.63,5.65a.5.5,0,0,1-.32-.11L17,1.15,11.69,5.54A.5.5,0,0,1,11,4.76L16.68.11a.5.5,0,0,1,.64,0L23,4.76a.5.5,0,0,1-.32.89Z" style="fill: #fff" />
        <path
            d="M30,34H4a4,4,0,0,1-4-4V15.72a3.32,3.32,0,0,1,1-2.6c.2-.18,1.66-1.4,4.47-3.72a.5.5,0,1,1,.64.77C2.65,13,1.77,13.75,1.64,13.86A2.27,2.27,0,0,0,1,15.72V30a3,3,0,0,0,3,3H30a3,3,0,0,0,3-3V15.72a2.27,2.27,0,0,0-.64-1.85c-.24-.21-2.65-2.21-4.44-3.7a.5.5,0,1,1,.64-.77c2.94,2.43,4.28,3.55,4.47,3.72a3.32,3.32,0,0,1,1,2.6V30A4,4,0,0,1,30,34Z"
            style="fill: #fff"
        />
        <path d="M28.23,17.77a.5.5,0,0,1-.5-.5V5.65H6.27V17.27a.5.5,0,0,1-1,0V5.15a.5.5,0,0,1,.5-.5H28.23a.5.5,0,0,1,.5.5V17.27A.5.5,0,0,1,28.23,17.77Z" style="fill: #fff" />
        <path d="M21.41,23.41a.5.5,0,0,1-.32-.89c5-4.1,10.91-9,11.31-9.37a.5.5,0,1,1,.67.74c-.52.47-9.53,7.91-11.34,9.4A.5.5,0,0,1,21.41,23.41Z" style="fill: #fff" />
        <path d="M12.59,23.41a.5.5,0,0,1-.32-.11C8.23,20,1.38,14.3.94,13.9a.5.5,0,1,1,.67-.74c.31.28,4.44,3.7,11.31,9.37a.5.5,0,0,1-.32.89Z" style="fill: #fff" />
        <path d="M1.32,32.76A.5.5,0,0,1,1,31.89c.65-.58,15.08-12.49,15.7-13a.5.5,0,0,1,.64,0c.61.51,15,12.41,15.7,13a.5.5,0,0,1-.67.74C31.76,32.11,19.18,21.72,17,19.92,14.82,21.72,2.24,32.11,1.65,32.63A.5.5,0,0,1,1.32,32.76Z" style="fill: #fff" />
        <path d="M19.7,9.89H14.3a.5.5,0,0,1,0-1H19.7a.5.5,0,0,1,0,1Z" style="fill: #fff" />
        <path d="M24,13.34H10a.5.5,0,0,1,0-1H24a.5.5,0,0,1,0,1Z" style="fill: #fff" />
        <path d="M24,16.8H10a.5.5,0,0,1,0-1H24a.5.5,0,0,1,0,1Z" style="fill: #fff" />
    </svg>
</template>

<script>
export default {
    name: "MailIcon",
};
</script>

<style scoped>
.cls-1 {
    fill: #fff;
    stroke-width: 0px;
}
</style>
./Contact.vue
